import { Link } from 'react-router-dom';
import { AlertCircle, PenLine } from 'lucide-react';
import { cn } from '@/lib/utils';
import { clearTranslationActivity, useTranslationActivity } from '@/lib/translationActivity';

const TRANSLATIONS_PATH = '/club/translations';

/**
 * One quiet line under the club portal's top bar, shown only when a translation
 * needs a person: a run that failed, or a hand-edited translation whose source
 * text moved on. Routine runs leave no trace here, so anything on this line is
 * worth reading. Following the link clears it — the club is acting on it.
 */
export function TranslationActivityLine() {
  const activity = useTranslationActivity();
  if (activity.status === 'idle') return null;

  const isError = activity.status === 'error';
  const Icon = isError ? AlertCircle : PenLine;
  const link = activity.link ?? { href: TRANSLATIONS_PATH, label: isError ? 'Open translations' : 'Review' };

  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        'flex items-center gap-2 h-8 px-4 lg:px-[26px] text-[13px] border-b border-border bg-card/60 flex-shrink-0',
        isError ? 'text-destructive' : 'text-warn',
      )}
    >
      <Icon className="w-3.5 h-3.5 flex-shrink-0" aria-hidden="true" />
      <span className="truncate">{activity.message}</span>
      <Link
        to={link.href}
        onClick={clearTranslationActivity}
        className="font-medium underline underline-offset-2 whitespace-nowrap"
      >
        {link.label}
      </Link>
    </div>
  );
}
